<div>
    <div class="reportsPage prodAvailability">
        <div class="row">
            <div class="col-md-10">
                <h3>Product Availability Search</h3>
                <p class="itemAvailText smalltext">
                    Filter and select product(s) below to see their current availability. Refine the list by selecting specific products from the search results. When you are ready, click the check availability button.
                </p>
            </div>
            <div class="col-md-2 text-right">
                <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
                <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
            </div>
        </div>

        <div class="search-box landingPageSearch">
            <form name="" action="">
                <span class="search-icon">
                    <i class="fas fa-search"></i>
                </span>
                <input type="hidden" #selectAccountHidden />
                <div class="select-container material-select">

                    <ng-select #select name="ddlAccount"
                               [items]="ddlAccounts"
                               [loading]="accountsLoading"
                               [(ngModel)]="selectedAccount"
                               [virtualScroll]="true"
                               bindLabel="accountNameCityState"
                               bindValue="accountNumber"
                               (change)="accountChange($event);"
                               (clear)="accountClear($event)"
                               class="custom-select-grower searchIcon lpSearch"
                               placeholder="Select Account"
                               [closeOnSelect]="true"
                               [searchFn]="accountSearchFn">

                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                                <div class="row">
                                    <div class="col-md-8">
                                        <h4 class="name" [ngOptionHighlight]="search">
                                            {{item.accountName}}
                                        </h4>
                                        <p class="address" [ngOptionHighlight]="search">
                                            {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                                        </p>
                                        <p class="phoneNo" [ngOptionHighlight]="search">
                                            {{item.primaryPhoneNumber}}
                                        </p>
                                        <p class="grower-nos">
                                            <span class="grower-gln" [ngOptionHighlight]="search">
                                                Account #: {{item.accountNumber}}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                                No data found for "{{searchTerm}}"
                            </div>
                        </ng-template>
                        <ng-template ng-footer-tmp let-search="searchTerm">
                            <div class="custom-drop-footer">
                                <div class="row">
                                    <div class="col-md-12">
                                        Select an option above to filter
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </form>
        </div>

        <div class="form-sec">
            <div class="row margin-t20 margin-b10">
                <div class="col-md-8 col-xl-10 smallPadRgt0">
                    <div class="row search-box-outer">
                        <div class="col-md-4 col-lg-3 padding-r0 borderRight padding-l0">

                            <div class="category-dropdown material-select">
                                <ng-select [items]="searchTypeList"
                                           name="ddlProductSearch"
                                           [(ngModel)]="selectedValue"
                                           (ngModelChange)="enableDisableSearch()"
                                           [virtualScroll]="true"
                                           [closeOnSelect]="true"
                                           [selectOnTab]="true"
                                           [clearable]="false"
                                           bindValue="value"
                                           labelForId="name"
                                           [searchable]="false"
                                           (change)="keepFilter()">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-8 col-lg-9 padding-l0 padding-r0">
                            <div class="material-select reports-search-filter">
                                <div #productSearch *ngIf="selectedValue === 'Product Name'">
                                    <div class="search-box-outer margin-l10">
                                        <div class="search-box wide100">
                                            <span class="search-icon">
                                                <i class="fas fa-search"></i>
                                            </span>
                                            <div class="select-container">
                                                <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateProductSearch()"
                                                       placeholder="Search Product" type="text">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Marketing Brand'"
                                           [items]="marketingMasterList"
                                           placeholder="Search Product"
                                           class="custom-select-grower"
                                           [multiple]="true"
                                           [hideSelected]="true"
                                           [(ngModel)]="productFilters.MarketingBrandList"
                                           [virtualScroll]="true"
                                           bindLabel="value"
                                           bindValue="value"
                                           [closeOnSelect]="true"
                                           [searchFn]="filterSearchFn"
                                           (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="dropdown-template">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <p class="name">
                                                        {{item.value}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                        <div class="ng-option disabled">
                                            No data found for "{{searchTerm}}"
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                                           [items]="seedsizeMasterList"
                                           placeholder="Search Product"
                                           [multiple]="true"
                                           [hideSelected]="true"
                                           class="custom-select-grower"
                                           [(ngModel)]="productFilters.SeedSizeList"
                                           [virtualScroll]="true"
                                           bindLabel="value"
                                           bindValue="value"
                                           [closeOnSelect]="true"
                                           [searchFn]="filterSearchFn"
                                           (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="dropdown-template">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <p class="name">
                                                        {{item.value}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                        <div class="ng-option disabled">
                                            No data found for "{{searchTerm}}"
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                                           [items]="packagesizeMasterList"
                                           placeholder="Search Product"
                                           class="custom-select-grower"
                                           [multiple]="true"
                                           [hideSelected]="true"
                                           [(ngModel)]="productFilters.PackageSizeList"
                                           [virtualScroll]="true"
                                           bindLabel="value"
                                           bindValue="value"
                                           [closeOnSelect]="true"
                                           [searchFn]="filterSearchFn"
                                           (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="dropdown-template">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <p class="name">
                                                        {{item.value}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                        <div class="ng-option disabled">
                                            No data found for "{{searchTerm}}"
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div #productSearch *ngIf="selectedValue === 'Technology'">
                                    <div class="search-box-outer margin-l10">
                                        <div class="search-box wide100">
                                            <span class="search-icon">
                                                <i class="fas fa-search"></i>
                                            </span>
                                            <div class="select-container">
                                                <input (keyup.enter)="keepFilter();getProducts();" [(ngModel)]="productFilters.TechnologyList" (ngModelChange)="validateTechnologySearch()"
                                                       placeholder="Search Product" type="text">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Treatment'"
                                           [items]="treatmentMasterList"
                                           placeholder="Search Product"
                                           class="custom-select-grower"
                                           [multiple]="true"
                                           [hideSelected]="true"
                                           [(ngModel)]="productFilters.TreatmentList"
                                           [virtualScroll]="true"
                                           bindLabel="value"
                                           bindValue="value"
                                           [closeOnSelect]="true"
                                           [searchFn]="filterSearchFn"
                                           (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="dropdown-template">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <p class="name">
                                                        {{item.value}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                        <div class="ng-option disabled">
                                            No data found for "{{searchTerm}}"
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <ng-select #productSearch name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                                           [items]="productLineMasterList"
                                           placeholder="Search Product"
                                           class="custom-select-grower"
                                           [multiple]="true"
                                           [hideSelected]="true"
                                           [(ngModel)]="productFilters.ProductLineList"
                                           [virtualScroll]="true"
                                           bindLabel="value"
                                           bindValue="value"
                                           [closeOnSelect]="true"
                                           [searchFn]="filterSearchFn"
                                           (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <div class="dropdown-template">
                                            <div class="row">
                                                <div class="col-md-8">
                                                    <p class="name">
                                                        {{item.value}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                        <div class="ng-option disabled">
                                            No data found for "{{searchTerm}}"
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div class="col-md-6 maturitySelect padding-l0 padding-r0" *ngIf="selectedValue === 'Maturity'">
                                    <ng-select #productSearch name="ddlproductSearch"
                                               [items]="maturityMasterList"
                                               placeholder="Min"
                                               class="custom-select-grower "
                                               [hideSelected]="true"
                                               [(ngModel)]="productFilters.MaturityMin"
                                               [virtualScroll]="true"
                                               bindLabel="value"
                                               bindValue="value"
                                               [closeOnSelect]="true"
                                               [searchFn]="filterSearchFn"
                                               (change)="keepFilter()">
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                            <div class="dropdown-template">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <p class="name">
                                                            {{item.value}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                            <div class="ng-option disabled">
                                                No data found for "{{searchTerm}}"
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="col-md-6 maturitySelect padding-l0 padding-r0" *ngIf="selectedValue === 'Maturity'">
                                    <ng-select #productSearch name="ddlproductSearch"
                                               [items]="maturityMasterList"
                                               placeholder="Max"
                                               class="custom-select-grower"
                                               [hideSelected]="true"
                                               [(ngModel)]="productFilters.MaturityMax"
                                               [virtualScroll]="true"
                                               bindLabel="value"
                                               bindValue="value"
                                               [closeOnSelect]="true"
                                               [searchFn]="filterSearchFn"
                                               (change)="keepFilter()">
                                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                            <div class="dropdown-template">
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <p class="name">
                                                            {{item.value}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                            <div class="ng-option disabled">
                                                No data found for "{{searchTerm}}"
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-xl-2 padding-l10 text-md-left text-sm-right">
                    <div class="search-btn search-btn-outer">
                        <button mat-raised-button class="btns height-36" color="primary" (click)="keepFilter();getProducts()" [disabled]="isTextBoxEmpty || !isAccountSelected">Search</button>
                    </div>
                    <div class="search-btn search-btn-outer text-right padding-l5">
                        <button mat-raised-button class="btns height-36" color="primary" (click)="keepFilter();getProductsAvailabilityEmailReport1()" [disabled]="isTextBoxEmpty || !isAccountSelected">Email Report</button>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="chips-sec">
                    <div class="row selected-chip padding-l0">
                        <div class="col-sm-9 col-md-9 padding-l0">
                            <div>
                                <mat-chip-set>
                                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                                        {{filterValue}}
                                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                                            <i class="fas fa-times text-right"></i>
                                        </a>
                                    </mat-chip>
                                </mat-chip-set>
                            </div>
                        </div>
                        <div class="col-sm-3 col-md-2 padding-r0 text-right" *ngIf="filterValueList.length > 0">
                            <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 padding-l30 padding-r0 padding-b10 padding-t10">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="row">
                            <div class="col-md-9 padding-r30 padding-l0 text-left">
                                <div class="row">
                                    <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                                        <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                                    </div>
                                    <div class="col-sm-3 col-md-3 padding-r30 padding-t5">
                                        <p *ngIf="currentFilter.filterDescription">
                                            LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                                        </p>
                                    </div>
                                    <div class="col-sm-3 col-md-3 padding-r30">
                                        <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription" [disabled]="isTextBoxEmpty || !isAccountSelected">Edit Report</button>
                                        <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription" [disabled]="isTextBoxEmpty || !isAccountSelected">Save</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 text-right">
                                <div class="padding-r0 ">
                                    <button mat-raised-button class="btns" color="primary" (click)="addFilter()" [disabled]="isTextBoxEmpty || !isAccountSelected">Create Report</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 margin-t5">
                <h4>Search Result</h4>
                <p class="itemAvailText">
                    Grid display all product for selected filter criteria but maximum of 250 records can be selected to display the availability. Please use "Email report" option if you want the report for all products.
                </p>
            </div>
            <div class="col-md-12">
                <div class="fulfill-top-sec">
                    <div class="row listing-action-items">
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="selectAllcheckSec">
                                <mat-checkbox (change)="productToggle()" [disabled]="productList.length <=0" [(ngModel)]="this.selectAll"
                                              [indeterminate]="productDataSource?.data?.length > 0 && !isAllProductSelected() && isProductSelected()" class="custom-checkbox select-all-check">
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                            <mat-paginator #productPaginator [pageSize]="250" [pageSizeOptions]="[250]" (page)="onPaginateChange()"></mat-paginator>
                        </div>
                    </div>
                </div>
                <div class="tableContainer">
                    <table mat-table #productTable [dataSource]="productDataSource" matSort (matSortChange)="onPaginateChange()" matSortDirection="desc" class="matTables productTable resultTable">
                        <ng-container matColumnDef="ProductId">
                            <th mat-header-cell *matHeaderCellDef class="chkbox">
                                &nbsp;
                                <!--<div class="col-xl-4 col-lg-4 col-md-4">
                                 <div class="selectAllcheckSec">
                                  <mat-checkbox (change)="productToggle()" [disabled]="productList.length <=0"
                                         [checked]="isAllProductSelected()"
                                         [indeterminate]="!isAllProductSelected() && selectedCount > 0" class="custom-checkbox select-all-check">
                                  </mat-checkbox>
                                 </div>
                                </div>-->
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-checkbox #SingleCheck
                                              (change)="$event ? productCheckEvent(element, SingleCheck._checked): null;"
                                              [checked]="element.IsProductSelected" class="custom-checkbox">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="itemDescription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="productNameBlock">Product Name </th>
                            <td mat-cell *matCellDef="let element" class="order-info">
                                <p> {{element.brand}} - {{element.marketingBrand}}</p>
                                <p class="grower-name">
                                    <a>
                                        {{element.itemDescription}}
                                    </a>
                                </p>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="seedAvailability">
                            <th mat-header-cell [style.display]="'none'" mat-sort-header *matHeaderCellDef class="text-center margin-t0 availabilityCol"> Availability </th>
                            <td mat-cell [style.display]="'none'" *matCellDef="let element" class="text-center"> {{element.seedAvailability}} </td>
                        </ng-container>

                        <ng-container matColumnDef="maturity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center maturityCol"> Maturity </th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.maturity}} </td>
                        </ng-container>
                        <!-- Name Column -->
                        <ng-container matColumnDef="seedSize">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center seedSizeCol"> Seed Size </th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.seedSize}} </td>
                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="packageSize">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center packageSizeCol"> Package Size </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" title="{{element.packageSize}}">
                                    {{element.packageSize}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="treatment">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center treatmentCol"> Treatment </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'treatment': (element.highlightTreatment===1)}" title="{{element.treatment}}">
                                    {{element.treatment}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="technology">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center techCol"> Technology </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" title="{{element.technology}}">
                                    {{element.technology}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="marketingBrand">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center marketingBrandCol"> Marketing Brand </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'treatment': (element.marketingBrand===1)}" title="{{element.marketingBrand}}">
                                    {{element.marketingBrand}}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Symbol Column -->
                        <ng-container matColumnDef="productLine">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center productLineCol"> Product Line </th>
                            <td mat-cell *matCellDef="let element" class="product-line text-center">
                                <span>
                                    {{element.productLine}}
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="searchResultDisplayedColumns;sticky:true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: searchResultDisplayedColumns;"></tr>
                        <!--<tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>-->
                        <!--<tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'active':row.IsProductSelected}" (click)="keepRecords(row)"></tr>-->
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <h4>SELECT PRODUCT TO SEARCH AVAILABILITY (Max 250 Items):</h4>
                <p class="itemAvailText">Below are the product(s) you have selected for the availability report. If you wish to remove any, click on the trash can next to the product.</p>
            </div>

            <div class="col-md-12 orderQuantity">
                <span class="padding-t20">Display product with availability > 0</span>
                <mat-checkbox class="custom-checkbox margin-l10"
                              #getZeroQtyRecords
                              [checked]="ignoreZeroQtyRecords"
                              (change)="filterNonZeroAvailabilityDetail(getZeroQtyRecords._checked)"
                              title="Display product with Availability > 0"></mat-checkbox>
            </div>

            <div class="col-md-12 selectedProdTableOuter">
                <div class="fulfill-top-sec">
                    <div class="row listing-action-items">
                        <div class="col-xl-4 col-lg-4 col-md-4">
                            <div class="selectAllcheckSec">
                                <div class="delete-prod">
                                    <div class="chkboxOuter">
                                        <i class="icon-ico-trash" title="Delete All" (click)="removeRecords(null)"></i>
                                        <!--<mat-checkbox (change)="removeRecords(null)" [disabled]="bucketSelectedCount <=0"
                                               [checked]="bucketSelectedCount > 0" class="custom-checkbox select-all-check">
                                        </mat-checkbox>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                            <mat-paginator #bucketPaginator [pageSize]="250" [pageSizeOptions]="[250]"></mat-paginator>
                        </div>
                    </div>
                </div>
                <div class="tableContainer">
                    <table mat-table #bucketTable [dataSource]="bucketListDS" matSort matSortDirection="desc" class="matTables productTable selectedProdTable">
                        <ng-container matColumnDef="ProductId">
                            <th mat-header-cell *matHeaderCellDef class="chkbox">
                                &nbsp;
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="delete-prod">
                                    <div class="chkboxOuter">
                                        <i class="icon-ico-trash" title="Delete" (click)="removeRecords(element)"></i>
                                        <!--<mat-checkbox #SingleCheck
                                               (change)="removeRecords(element)"
                                               [checked]="element.IsProductSelected" class="custom-checkbox">
                                        </mat-checkbox>-->
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="itemDescription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="productNameBlock">Product Name </th>
                            <td mat-cell *matCellDef="let element" class="order-info">
                                <p> {{element.brand}} - {{element.marketingBrand}}</p>
                                <p class="grower-name">
                                    <a>
                                        {{element.itemDescription}}
                                    </a>
                                </p>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="seedAvailability">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center margin-t0 availabilityCol"> Availability </th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.seedAvailability}} </td>
                        </ng-container>

                        <ng-container matColumnDef="maturity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center maturityCol"> Maturity </th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.maturity}} </td>
                        </ng-container>

                        <ng-container matColumnDef="seedSize">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center seedSizeCol"> Seed Size </th>
                            <td mat-cell *matCellDef="let element" class="text-center"> {{element.seedSize}} </td>
                        </ng-container>

                        <ng-container matColumnDef="packageSize">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center packageSizeCol"> Package Size </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'pack-size': (element.highlightPackage===1)}" title="{{element.packageSize}}">
                                    {{element.packageSize}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="treatment">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center treatmentCol"> Treatment </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'treatment': (element.highlightTreatment===1)}" title="{{element.treatment}}">
                                    {{element.treatment}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="technology">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center techCol"> Technology </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'technology': (element.highlightTechnology===1)}" title="{{element.technology}}">
                                    {{element.technology}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="marketingBrand">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center marketingBrandCol"> Marketing Brand </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <span class="oval-shape" [ngClass]="{'treatment': (element.marketingBrand===1)}" title="{{element.marketingBrand}}">
                                    {{element.marketingBrand}}
                                </span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="productLine">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center productLineCol"> Product Line </th>
                            <td mat-cell *matCellDef="let element" class="product-line text-center">
                                <span>
                                    {{element.productLine}}
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <!--<tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'active':row.IsProductSelected}" (click)="removeRecords(row)"></tr>-->
                    </table>
                </div>
            </div>
        </div>

        <div class="row lineItemBtnSec">
          <div class="col-md-8 ">
            <!--<button mat-raised-button class="btns" color="primary" [disabled]="!isAccountSelected || selectedProductList.length<=0" (click)="getProductAvailability()">Display Availability</button>-->
            <button mat-raised-button class="btns" color="primary" [disabled]="!isAccountSelected || selectedProductList.length<=0" (click)="getProductsAvailability()">Display Availability</button>
            <button mat-raised-button class="btns" color="primary" [disabled]="productAvailabilityList.length<=0 || selectedProductList.length<=0" (click)="export()">Export</button>
            <a style="cursor:pointer" (click)="onCancel()">Cancel </a>
          </div>
          <div class="col-md-4 text-right" *ngIf="chatAccess">
            Product Selected:
            <span class="count" style="margin-right: 50px;"> {{selectedCount}} </span>
          </div>
          <div class="col-md-4 text-right" *ngIf="!chatAccess">
            Product Selected:
            <span class="count"> {{selectedCount}} </span>
          </div>
        </div>
    </div>
</div>
